import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

import {
  HOME_PATH, HOME_PATHNAME,
  // Top Bar Dropdown Menu
  LOGIN_PATH, LOGIN_PATHNAME,
  PROFILE_PATH, PROFILE_PATHNAME,
  HELP_PATH, HELP_PATHNAME,
  ABOUT_PATH, ABOUT_PATHNAME,
  CONTACT_PATH, CONTACT_PATHNAME,
  LOGOUT_PATH, LOGOUT_PATHNAME,

  // User Routes
  USER_PATH, USER_PATHNAME,
  USER_LIST_PATH, USER_LIST_PATHNAME,
  USER_ADD_PATH, USER_ADD_PATHNAME,

  // Consumer Routes
  CONSUMER_PATH, CONSUMER_PATHNAME,
  CONSUMER_LIST_PATH, CONSUMER_LIST_PATHNAME,
  CONSUMER_ADD_PATH, CONSUMER_ADD_PATHNAME,

  // Deliverable Routes
  DELIVERABLE_PATH, DELIVERABLE_PATHNAME,
  DELIVERABLE_LIST_PATH, DELIVERABLE_LIST_PATHNAME,
  DELIVERABLE_ADD_PATH, DELIVERABLE_ADD_PATHNAME,
  DELIVERABLE_ASSIGN_PATH, DELIVERABLE_ASSIGN_PATHNAME,
  DELIVERABLE_EDIT_PATH, DELIVERABLE_EDIT_PATHNAME,

  // Version Routes
  VERSION_PATH, VERSION_PATHNAME,
  VERSION_LIST_PATH, VERSION_LIST_PATHNAME,
  VERSION_ADD_PATH, VERSION_ADD_PATHNAME,

  // IDS Policy Routes
  IDSPOLICY_PATH, IDSPOLICY_PATHNAME,
  IDSPOLICY_OS_PATH, IDSPOLICY_OS_PATHNAME,
  IDSPOLICY_CLIENT_PATH, IDSPOLICY_CLIENT_PATHNAME,
  IDSPOLICY_DETAIL_PATH, IDSPOLICY_DETAIL_PATHNAME,
  ADD_IDSPOLICY_PATH, ADD_IDSPOLICY_PATHNAME,
  EDIT_IDSPOLICY_PATH, EDIT_IDSPOLICY_PATHNAME,
  DUPLICATE_IDSPOLICY_PATH, DUPLICATE_IDSPOLICY_PATHNAME,

  // Remote Policy Routes
  REMOTE_POLICY_PATH, REMOTE_POLICY_PATHNAME,
  REMOTE_POLICY_LIST_PATH, REMOTE_POLICY_LIST_PATHNAME,
  REMOTE_POLICY_ADD_PATH, REMOTE_POLICY_ADD_PATHNAME,
  REMOTE_POLICY_EDIT_PATH, REMOTE_POLICY_EDIT_PATHNAME,

  // Remote Report Policy Routes
  REMOTE_REPORT_POLICY_PATH, REMOTE_REPORT_POLICY_PATHNAME,
  REMOTE_REPORT_POLICY_LIST_PATH, REMOTE_REPORT_POLICY_LIST_PATHNAME,
  REMOTE_REPORT_POLICY_ADD_PATH, REMOTE_REPORT_POLICY_ADD_PATHNAME,
  REMOTE_REPORT_POLICY_EDIT_PATH, REMOTE_REPORT_POLICY_EDIT_PATHNAME,

  // IDS Policy Template Routes
  IDSPOLICY_TEMP_PATH, IDSPOLICY_TEMP_PATHNAME,
  IDSPOLICY_TEMP_OS_PATH, IDSPOLICY_TEMP_OS_PATHNAME,
  IDSPOLICY_TEMP_DETAIL_PATH, IDSPOLICY_TEMP_DETAIL_PATHNAME,
  IDSPOLICY_TEMP_EDIT_PATH, IDSPOLICY_TEMP_EDIT_PATHNAME,
  IDSPOLICY_TEMP_ADD_PATH, IDSPOLICY_TEMP_ADD_PATHNAME,

  // Deliverable Type Routes
  DELIVERABLE_TYPE_PATH, DELIVERABLE_TYPE_PATHNAME,
  DELIVERABLE_TYPE_LIST_PATH, DELIVERABLE_TYPE_LIST_PATHNAME,
  DELIVERABLE_TYPE_ADD_PATH, DELIVERABLE_TYPE_ADD_PATHNAME,

  // Target OS Routes
  TARGET_OS_PATH, TARGET_OS_PATHNAME,
  TARGET_OS_LIST_PATH, TARGET_OS_LIST_PATHNAME,
  TARGET_OS_ADD_PATH, TARGET_OS_ADD_PATHNAME,

  // Artefacts Routes
  ARTEFACT_PATH, ARTEFACT_PATHNAME,
  ARTEFACT_VERSION_LIST_PATH, ARTEFACT_VERSION_LIST_PATHNAME,
  ARTEFACT_LIST_PATH, ARTEFACT_LIST_PATHNAME,
  ARTEFACT_ADD_PATH, ARTEFACT_ADD_PATHNAME,
  ARTEFACT_EDIT_PATH, ARTEFACT_EDIT_PATHNAME,

  // Gitlab Routes
  GITLAB_PATH, GITLAB_PATHNAME,
  GITLAB_LIST_PATH, GITLAB_LIST_PATHNAME,
  GITLAB_ADD_PATH, GITLAB_ADD_PATHNAME,
  GITLAB_EDIT_PATH, GITLAB_EDIT_PATHNAME,

  // Artifact Repository Routes
  ARTIFACT_REPO_PATH, ARTIFACT_REPO_PATHNAME,
  ARTIFACT_REPO_LIST_PATH, ARTIFACT_REPO_LIST_PATHNAME,
  ARTIFACT_REPO_ADD_PATH, ARTIFACT_REPO_ADD_PATHNAME,
  ARTIFACT_REPO_EDIT_PATH, ARTIFACT_REPO_EDIT_PATHNAME,

  // Auto Pentest Routes
  AUTO_PENTEST_PATH, AUTO_PENTEST_PATHNAME,
  AUTO_PENTEST_LIST_PATH, AUTO_PENTEST_LIST_PATHNAME,
  AUTO_PENTEST_ADD_PATH, AUTO_PENTEST_ADD_PATHNAME,

  // Entity Routes
  ENTITY_PATH, ENTITY_PATHNAME,
  ENTITY_LIST_PATH, ENTITY_LIST_PATHNAME,
  ENTITY_ADD_PATH, ENTITY_ADD_PATHNAME,

  // Product Routes
  PRODUCT_PATH, PRODUCT_PATHNAME,
  PRODUCT_LIST_PATH, PRODUCT_LIST_PATHNAME,
  PRODUCT_ADD_PATH, PRODUCT_ADD_PATHNAME,

  // Whitebox Keys
  WBK_PATH, WBK_PATHNAME,
  WBK_LIST_PATH, WBK_LIST_PATHNAME,

  // KeySets
  KS_PATH, KS_PATHNAME,
  KS_LIST_PATH, KS_LIST_PATHNAME,

  // BW Certificates
  BW_CRT_PATH, BW_CRT_PATHNAME,
  BW_CRT_LIST_PATH, BW_CRT_LIST_PATHNAME,

  // Tokens
  TOKEN_PATH, TOKEN_PATHNAME,
  TOKEN_LIST_PATH, TOKEN_LIST_PATHNAME,
  TOKEN_ADD_PATH, TOKEN_ADD_PATHNAME,
  TOKEN_EDIT_PATH, TOKEN_EDIT_PATHNAME,

  // IDS Report Policy Template Routes
  IDSREPORTPOLICY_TEMP_PATH, IDSREPORTPOLICY_TEMP_PATHNAME,
  IDSREPORTPOLICY_TEMP_OS_PATH, IDSREPORTPOLICY_TEMP_OS_PATHNAME,
  IDSREPORTPOLICY_TEMP_DETAIL_PATH, IDSREPORTPOLICY_TEMP_DETAIL_PATHNAME,
  IDSREPORTPOLICY_TEMP_EDIT_PATH, IDSREPORTPOLICY_TEMP_EDIT_PATHNAME,
  IDSREPORTPOLICY_TEMP_ADD_PATH, IDSREPORTPOLICY_TEMP_ADD_PATHNAME,

  // IDS Report Policy Routes
  IDSREPORTPOLICY_PATH, IDSREPORTPOLICY_PATHNAME,
  IDSREPORTPOLICY_OS_PATH, IDSREPORTPOLICY_OS_PATHNAME,
  IDSREPORTPOLICY_CLIENT_PATH, IDSREPORTPOLICY_CLIENT_PATHNAME,
  IDSREPORTPOLICY_DETAIL_PATH, IDSREPORTPOLICY_DETAIL_PATHNAME,
  ADD_IDSREPORTPOLICY_PATH, ADD_IDSREPORTPOLICY_PATHNAME,
  EDIT_IDSREPORTPOLICY_PATH, EDIT_IDSREPORTPOLICY_PATHNAME,
  DUPLICATE_IDSREPORTPOLICY_PATH, DUPLICATE_IDSREPORTPOLICY_PATHNAME

} from 'common/const.js'

// Route Lazy Load
const BaseContent = () => import(/* webpackChunkName: "base" */ 'views/baseContent/BaseContent.vue')
const Login = () => import(/* webpackChunkName: "login" */ 'views/login/Login.vue')
const Home = () => import(/* webpackChunkName: "home" */ 'views/home/Home.vue')
const About = () => import(/* webpackChunkName: "about" */ 'views/about/About.vue')
const Contact = () => import(/* webpackChunkName: "contact" */ 'views/contact/Contact.vue')
const Profile = () => import(/* webpackChunkName: "profile" */ 'views/profile/Profile.vue')
const Users = () => import(/* webpackChunkName: "users" */ 'views/users/Users.vue')
const Consumers = () => import(/* webpackChunkName: "consumers" */ 'views/consumers/Consumers.vue')
const Deliverables = () => import(/* webpackChunkName: "deliverables" */ 'views/deliverables/Deliverables.vue')
const Versions = () => import(/* webpackChunkName: "versions" */ 'views/versions/Versions.vue')
const DeliverableTypes = () => import(/* webpackChunkName: "deliverabletype" */ 'views/deliverableTypes/DeliverableTypes.vue')
const IdsPolicies = () => import(/* webpackChunkName: "idspolicies" */ 'views/idspolicies/IdsPolicies.vue')
const IdsPolicyTemps = () => import(/* webpackChunkName: "idsplctemp" */ 'views/idspolicyTemps/IdsPlcTemps.vue')
const RemotePolicies = () => import(/* webpackChunkName: "rmtplc" */ 'views/remotePolicies/RemotePolicies.vue')
const RemoteReportPolicies = () => import(/* webpackChunkName: "rmtrptplc" */ 'views/remoteReportPolicies/RemoteReportPolicies.vue')
const TargetOS = () => import(/* webpackChunkName: "targetos" */ 'views/targetOS/TargetOS.vue')
const Artefacts = () => import(/* webpackChunkName: "artefact" */ 'views/artefacts/Artefacts.vue')
const GitlabProjects = () => import(/* webpackChunkName: "gitlabproject" */ 'views/gitlabProjects/GitlabProjects.vue')
const ArtifactRepos = () => import(/* webpackChunkName: "artifactrepo" */ 'views/artifactRepos/ArtifactRepos.vue')
const AutoPentests = () => import(/* webpackChunkName: "autopentest" */ 'views/autoPentests/AutoPentests.vue')
const Entities = () => import(/* webpackChunkName: "entity" */ 'views/entities/Entities.vue')
const Products = () => import(/* webpackChunkName: "product" */ 'views/products/Products.vue')
const Wbks = () => import(/* webpackChunkName: "wbk" */ 'views/whiteBoxKeys/WhiteBoxKeys.vue')
const Ks = () => import(/* webpackChunkName: "ks" */ 'views/keySets/KeySets.vue')
const BWCrts = () => import(/* webpackChunkName: "crt" */ 'views/bwCertificates/BWCertificates.vue')
const Tokens = () => import(/* webpackChunkName: "token" */ 'views/tokens/Tokens.vue')
const NotFound = () => import(/* webpackChunkName: "notfound" */ 'views/notfound/NotFound.vue')
const IdsReportPolicies = () => import(/* webpackChunkName: "idsreportpolicies" */ 'views/idsreportpolicies/IdsReportPolicies.vue')
const IdsReportPolicyTemps = () => import(/* webpackChunkName: "idsreportplctemp" */ 'views/idsreportpolicyTemps/IdsReportPlcTemps.vue')

Vue.use(VueRouter)

const routes = [
  {
    // Parent Route
    path: '/',
    component: BaseContent,
    redirect: HOME_PATH,
    // Child Routes
    children: [
      {
        path: HOME_PATH,
        name: HOME_PATHNAME,
        component: Home
      },
      {
        path: PROFILE_PATH,
        name: PROFILE_PATHNAME,
        component: Profile
      },
      {
        path: HELP_PATH,
        name: HELP_PATHNAME
      },
      {
        path: ABOUT_PATH,
        name: ABOUT_PATHNAME,
        component: About
      },
      {
        path: CONTACT_PATH,
        name: CONTACT_PATHNAME,
        component: Contact
      },
      {
        path: LOGIN_PATH,
        name: LOGIN_PATHNAME,
        component: Login,
        beforeEnter: (to, from, next) => {
          if (store.state.isLoggedIn) {
            next({ path: HOME_PATH })
          } else {
            next()
          }
        }
      },
      {
        path: LOGOUT_PATH,
        name: LOGOUT_PATHNAME,
        redirect: () => {
          store.dispatch('logoutAction')
          return LOGIN_PATH
        }
      },
      {
        path: USER_PATH,
        name: USER_PATHNAME,
        component: Users,
        meta: {
          requireAuth: true
        },
        redirect: { name: USER_LIST_PATHNAME },
        children: [
          {
            path: USER_LIST_PATH,
            name: USER_LIST_PATHNAME,
            component: () => import(/* webpackChunkName: "users" */ 'views/users/UserList.vue')
          },
          {
            path: USER_ADD_PATH,
            name: USER_ADD_PATHNAME,
            component: () => import(/* webpackChunkName: "users" */ 'views/users/UserAdd.vue')
          }
        ]
      },
      {
        path: CONSUMER_PATH,
        name: CONSUMER_PATHNAME,
        component: Consumers,
        meta: {
          requireAuth: true
        },
        redirect: { name: CONSUMER_LIST_PATHNAME },
        children: [
          {
            path: CONSUMER_LIST_PATH,
            name: CONSUMER_LIST_PATHNAME,
            component: () => import(/* webpackChunkName: "consumers" */ 'views/consumers/ConsumerList.vue')
          },
          {
            path: CONSUMER_ADD_PATH,
            name: CONSUMER_ADD_PATHNAME,
            component: () => import(/* webpackChunkName: "consumers" */ 'views/consumers/ConsumerAdd.vue')
          }
        ]
      },
      {
        path: DELIVERABLE_PATH,
        name: DELIVERABLE_PATHNAME,
        component: Deliverables,
        meta: {
          requireAuth: true
        },
        redirect: { name: DELIVERABLE_LIST_PATHNAME },
        children: [
          {
            path: DELIVERABLE_LIST_PATH,
            name: DELIVERABLE_LIST_PATHNAME,
            component: () => import(/* webpackChunkName: "deliverables" */ 'views/deliverables/DeliverableList.vue')
          },
          {
            path: DELIVERABLE_ADD_PATH,
            name: DELIVERABLE_ADD_PATHNAME,
            component: () => import(/* webpackChunkName: "deliverables" */ 'views/deliverables/DeliverableAdd.vue')
          },
          {
            path: DELIVERABLE_EDIT_PATH,
            name: DELIVERABLE_EDIT_PATHNAME,
            component: () => import(/* webpackChunkName: "deliverables" */ 'views/deliverables/DeliverableEdit.vue'),
            beforeEnter (to, from, next) {
              if (!to.params.selectedDev) {
                next({ name: DELIVERABLE_LIST_PATHNAME })
              } else {
                next()
              }
            }
          },
          {
            path: DELIVERABLE_ASSIGN_PATH,
            name: DELIVERABLE_ASSIGN_PATHNAME,
            component: () => import(/* webpackChunkName: "deliverablesAssign" */ 'views/deliverables/DeliverableAssign.vue'),
            beforeEnter (to, from, next) {
              if (!to.params.id) {
                next({ name: DELIVERABLE_PATHNAME })
              } else {
                next()
              }
            }
          }
        ]
      },
      {
        path: VERSION_PATH,
        name: VERSION_PATHNAME,
        component: Versions,
        meta: {
          requireAuth: true
        },
        redirect: { name: VERSION_LIST_PATHNAME },
        children: [
          {
            path: VERSION_LIST_PATH,
            name: VERSION_LIST_PATHNAME,
            component: () => import(/* webpackChunkName: "versions" */ 'views/versions/VersionList.vue')
          },
          {
            path: VERSION_ADD_PATH,
            name: VERSION_ADD_PATHNAME,
            component: () => import(/* webpackChunkName: "versions" */ 'views/versions/VersionAdd.vue')
          }
        ],
        beforeEnter (to, from, next) {
          if (!to.params.id) {
            next({ name: DELIVERABLE_PATHNAME })
          } else {
            next()
          }
        }
      },
      {
        path: IDSPOLICY_PATH,
        name: IDSPOLICY_PATHNAME,
        component: IdsPolicies,
        meta: {
          requireAuth: true
        },
        redirect: { name: IDSPOLICY_OS_PATHNAME },
        children: [
          {
            path: IDSPOLICY_OS_PATH,
            name: IDSPOLICY_OS_PATHNAME,
            component: () => import(/* webpackChunkName: "idspolicies" */ 'views/idspolicies/IdsPlcOS.vue')
          },
          {
            path: IDSPOLICY_CLIENT_PATH,
            name: IDSPOLICY_CLIENT_PATHNAME,
            component: () => import(/* webpackChunkName: "idspolicies" */ 'views/idspolicies/IdsPlcClientList.vue')
          },
          {
            path: IDSPOLICY_DETAIL_PATH,
            name: IDSPOLICY_DETAIL_PATHNAME,
            component: () => import(/* webpackChunkName: "idsplcdetails" */ 'views/idspolicies/idsPlcDetails/IdsPlcDetails.vue'),
            beforeEnter (to, from, next) {
              if (!to.params.id) {
                next({ name: IDSPOLICY_PATHNAME })
              } else {
                next()
              }
            }
          },
          {
            path: ADD_IDSPOLICY_PATH,
            name: ADD_IDSPOLICY_PATHNAME,
            component: () => import(/* webpackChunkName: "addidspolicies" */ 'views/idspolicies/idsPlcAdd/IdsPlcAdd.vue')
          },
          {
            path: EDIT_IDSPOLICY_PATH,
            name: EDIT_IDSPOLICY_PATHNAME,
            component: () => import(/* webpackChunkName: "editidspolicies" */ 'views/idspolicies/idsPlcEdit/IdsPlcEdit.vue'),
            beforeEnter (to, from, next) {
              if (!to.params.id || !to.params.plcJson || !to.params.title) {
                next({ name: IDSPOLICY_PATHNAME })
              } else {
                next()
              }
            }
          },
          {
            path: DUPLICATE_IDSPOLICY_PATH,
            name: DUPLICATE_IDSPOLICY_PATHNAME,
            component: () => import(/* webpackChunkName: "editidspolicies" */ 'views/idspolicies/idsPlcDup/IdsPlcDup.vue'),
            beforeEnter (to, from, next) {
              if (!to.params.id || !to.params.plcJson || !to.params.title) {
                next({ name: IDSPOLICY_PATHNAME })
              } else {
                next()
              }
            }
          }
        ]
      },
      {
        path: IDSPOLICY_TEMP_PATH,
        name: IDSPOLICY_TEMP_PATHNAME,
        meta: {
          requireAuth: true
        },
        component: IdsPolicyTemps,
        redirect: { name: IDSPOLICY_TEMP_OS_PATHNAME },
        children: [
          {
            path: IDSPOLICY_TEMP_OS_PATH,
            name: IDSPOLICY_TEMP_OS_PATHNAME,
            component: () => import(/* webpackChunkName: "idsplctemp" */ 'views/idspolicyTemps/IdsPlcTempOS.vue')
          },
          {
            path: IDSPOLICY_TEMP_DETAIL_PATH,
            name: IDSPOLICY_TEMP_DETAIL_PATHNAME,
            component: () => import(/* webpackChunkName: "idsplctempdetail" */ 'views/idspolicyTemps/idsPlcTempDetails/IdsPlcTempDetails.vue'),
            beforeEnter (to, from, next) {
              if (!to.params.id) {
                next({ name: IDSPOLICY_TEMP_PATHNAME })
              } else {
                next()
              }
            }
          },
          {
            path: IDSPOLICY_TEMP_EDIT_PATH,
            name: IDSPOLICY_TEMP_EDIT_PATHNAME,
            component: () => import(/* webpackChunkName: "idsplctempedit" */ 'views/idspolicyTemps/idsPlcTempEdit/IdsPlcTempEdit.vue'),
            beforeEnter (to, from, next) {
              if (!to.params.id) {
                next({ name: IDSPOLICY_TEMP_PATHNAME })
              } else {
                next()
              }
            }
          },
          {
            path: IDSPOLICY_TEMP_ADD_PATH,
            name: IDSPOLICY_TEMP_ADD_PATHNAME,
            component: () => import(/* webpackChunkName: "idsplctempadd" */ 'views/idspolicyTemps/idsPlcTempAdd/IdsPlcTempAdd.vue')
          }
        ]
      },
      {
        path: REMOTE_POLICY_PATH,
        name: REMOTE_POLICY_PATHNAME,
        component: RemotePolicies,
        meta: {
          requireAuth: true
        },
        redirect: { name: REMOTE_POLICY_LIST_PATHNAME },
        children: [
          {
            path: REMOTE_POLICY_LIST_PATH,
            name: REMOTE_POLICY_LIST_PATHNAME,
            component: () => import(/* webpackChunkName: "remoteplc" */ 'views/remotePolicies/RemotePlcList.vue')
          },
          {
            path: REMOTE_POLICY_ADD_PATH,
            name: REMOTE_POLICY_ADD_PATHNAME,
            component: () => import(/* webpackChunkName: "remoteplcadd" */ 'views/remotePolicies/RemotePlcAdd.vue')
          },
          {
            path: REMOTE_POLICY_EDIT_PATH,
            name: REMOTE_POLICY_EDIT_PATHNAME,
            component: () => import(/* webpackChunkName: "remoteplcedit" */ 'views/remotePolicies/RemotePlcEdit.vue'),
            beforeEnter (to, from, next) {
              if (!to.params.remotePolicy) {
                next({ name: REMOTE_POLICY_LIST_PATHNAME })
              } else {
                next()
              }
            }
          }
        ]
      },
      {
        path: REMOTE_REPORT_POLICY_PATH,
        name: REMOTE_REPORT_POLICY_PATHNAME,
        component: RemoteReportPolicies,
        meta: {
          requireAuth: true
        },
        redirect: { name: REMOTE_REPORT_POLICY_LIST_PATHNAME },
        children: [
          {
            path: REMOTE_REPORT_POLICY_LIST_PATH,
            name: REMOTE_REPORT_POLICY_LIST_PATHNAME,
            component: () => import(/* webpackChunkName: "reportplc" */ 'views/remoteReportPolicies/RemoteReportPlcList.vue')
          },
          {
            path: REMOTE_REPORT_POLICY_ADD_PATH,
            name: REMOTE_REPORT_POLICY_ADD_PATHNAME,
            component: () => import(/* webpackChunkName: "reportplcadd" */ 'views/remoteReportPolicies/RemoteReportPlcAdd.vue')
          },
          {
            path: REMOTE_REPORT_POLICY_EDIT_PATH,
            name: REMOTE_REPORT_POLICY_EDIT_PATHNAME,
            component: () => import(/* webpackChunkName: "reportplcedit" */ 'views/remoteReportPolicies/RemoteReportPlcEdit.vue'),
            beforeEnter (to, from, next) {
              if (!to.params.reportPolicy) {
                next({ name: REMOTE_REPORT_POLICY_LIST_PATHNAME })
              } else {
                next()
              }
            }
          }
        ]
      },
      {
        path: DELIVERABLE_TYPE_PATH,
        name: DELIVERABLE_TYPE_PATHNAME,
        component: DeliverableTypes,
        meta: {
          requireAuth: true
        },
        redirect: { name: DELIVERABLE_TYPE_LIST_PATHNAME },
        children: [
          {
            path: DELIVERABLE_TYPE_LIST_PATH,
            name: DELIVERABLE_TYPE_LIST_PATHNAME,
            component: () => import(/* webpackChunkName: "deliverabletype" */ 'views/deliverableTypes/DeliverableTypeList.vue')
          },
          {
            path: DELIVERABLE_TYPE_ADD_PATH,
            name: DELIVERABLE_TYPE_ADD_PATHNAME,
            component: () => import(/* webpackChunkName: "deliverabletypeadd" */ 'views/deliverableTypes/DeliverableTypeAdd.vue')
          }
        ]
      },
      {
        path: TARGET_OS_PATH,
        name: TARGET_OS_PATHNAME,
        component: TargetOS,
        meta: {
          requireAuth: true
        },
        redirect: { name: TARGET_OS_LIST_PATHNAME },
        children: [
          {
            path: TARGET_OS_LIST_PATH,
            name: TARGET_OS_LIST_PATHNAME,
            component: () => import(/* webpackChunkName: "targetos" */ 'views/targetOS/TargetOSList.vue')
          },
          {
            path: TARGET_OS_ADD_PATH,
            name: TARGET_OS_ADD_PATHNAME,
            component: () => import(/* webpackChunkName: "targetosadd" */ 'views/targetOS/TargetOSAdd.vue')
          }
        ]
      },
      {
        path: ARTEFACT_PATH,
        name: ARTEFACT_PATHNAME,
        component: Artefacts,
        meta: {
          requireAuth: true
        },
        redirect: { name: ARTEFACT_VERSION_LIST_PATH },
        children: [
          {
            path: ARTEFACT_VERSION_LIST_PATH,
            name: ARTEFACT_VERSION_LIST_PATHNAME,
            component: () => import(/* webpackChunkName: "artefact" */ 'views/artefacts/ArtefactVersionList.vue')
          },
          {
            path: ARTEFACT_LIST_PATH,
            name: ARTEFACT_LIST_PATHNAME,
            component: () => import(/* webpackChunkName: "artefact" */ 'views/artefacts/ArtefactList.vue')
          },
          {
            path: ARTEFACT_ADD_PATH,
            name: ARTEFACT_ADD_PATHNAME,
            component: () => import(/* webpackChunkName: "artefactadd" */ 'views/artefacts/ArtefactAdd.vue')
          },
          {
            path: ARTEFACT_EDIT_PATH,
            name: ARTEFACT_EDIT_PATHNAME,
            component: () => import(/* webpackChunkName: "artefactedit" */ 'views/artefacts/ArtefactEdit.vue'),
            beforeEnter (to, from, next) {
              if (!to.params.selectedArt) {
                next({ name: ARTEFACT_LIST_PATHNAME })
              } else {
                next()
              }
            }
          }
        ]
      },
      {
        path: GITLAB_PATH,
        name: GITLAB_PATHNAME,
        component: GitlabProjects,
        meta: {
          requireAuth: true
        },
        redirect: { name: GITLAB_LIST_PATHNAME },
        children: [
          {
            path: GITLAB_LIST_PATH,
            name: GITLAB_LIST_PATHNAME,
            component: () => import(/* webpackChunkName: "gitlabproject" */ 'views/gitlabProjects/GitlabProjectList.vue')
          },
          {
            path: GITLAB_ADD_PATH,
            name: GITLAB_ADD_PATHNAME,
            component: () => import(/* webpackChunkName: "gitlabadd" */ 'views/gitlabProjects/GitlabProjectAdd.vue')
          },
          {
            path: GITLAB_EDIT_PATH,
            name: GITLAB_EDIT_PATHNAME,
            component: () => import(/* webpackChunkName: "gitlabedit" */ 'views/gitlabProjects/GitlabProjectEdit.vue'),
            beforeEnter (to, from, next) {
              if (!to.params.gp) {
                next({ name: GITLAB_LIST_PATHNAME })
              } else {
                next()
              }
            }
          }
        ]
      },
      {
        path: ARTIFACT_REPO_PATH,
        name: ARTIFACT_REPO_PATHNAME,
        component: ArtifactRepos,
        meta: {
          requireAuth: true
        },
        redirect: { name: ARTIFACT_REPO_LIST_PATHNAME },
        children: [
          {
            path: ARTIFACT_REPO_LIST_PATH,
            name: ARTIFACT_REPO_LIST_PATHNAME,
            component: () => import(/* webpackChunkName: "artifactrepo" */ 'views/artifactRepos/ArtifactRepoList.vue')
          },
          {
            path: ARTIFACT_REPO_ADD_PATH,
            name: ARTIFACT_REPO_ADD_PATHNAME,
            component: () => import(/* webpackChunkName: "artifactrepoadd" */ 'views/artifactRepos/ArtifactRepoAdd.vue')
          },
          {
            path: ARTIFACT_REPO_EDIT_PATH,
            name: ARTIFACT_REPO_EDIT_PATHNAME,
            component: () => import(/* webpackChunkName: "artifactrepoedit" */ 'views/artifactRepos/ArtifactRepoEdit.vue'),
            beforeEnter (to, from, next) {
              if (!to.params.ar) {
                next({ name: ARTIFACT_REPO_LIST_PATHNAME })
              } else {
                next()
              }
            }
          }
        ]
      },
      {
        path: AUTO_PENTEST_PATH,
        name: AUTO_PENTEST_PATHNAME,
        component: AutoPentests,
        meta: {
          requireAuth: true
        },
        redirect: { name: AUTO_PENTEST_LIST_PATHNAME },
        children: [
          {
            path: AUTO_PENTEST_LIST_PATH,
            name: AUTO_PENTEST_LIST_PATHNAME,
            component: () => import(/* webpackChunkName: "autopentest" */ 'views/autoPentests/AutoPentestList.vue')
          },
          {
            path: AUTO_PENTEST_ADD_PATH,
            name: AUTO_PENTEST_ADD_PATHNAME,
            component: () => import(/* webpackChunkName: "autopentestadd" */ 'views/autoPentests/AutoPentestAdd.vue')
          }
        ]
      },
      {
        path: ENTITY_PATH,
        name: ENTITY_PATHNAME,
        component: Entities,
        meta: {
          requireAuth: true
        },
        redirect: { name: ENTITY_LIST_PATHNAME },
        children: [
          {
            path: ENTITY_LIST_PATH,
            name: ENTITY_LIST_PATHNAME,
            component: () => import(/* webpackChunkName: "entity" */ 'views/entities/EntityList.vue')
          },
          {
            path: ENTITY_ADD_PATH,
            name: ENTITY_ADD_PATHNAME,
            component: () => import(/* webpackChunkName: "entityadd" */ 'views/entities/EntityAdd.vue')
          }
        ]
      },
      {
        path: PRODUCT_PATH,
        name: PRODUCT_PATHNAME,
        component: Products,
        meta: {
          requireAuth: true
        },
        redirect: { name: PRODUCT_LIST_PATHNAME },
        children: [
          {
            path: PRODUCT_LIST_PATH,
            name: PRODUCT_LIST_PATHNAME,
            component: () => import(/* webpackChunkName: "product" */ 'views/products/ProductList.vue')
          },
          {
            path: PRODUCT_ADD_PATH,
            name: PRODUCT_ADD_PATHNAME,
            component: () => import(/* webpackChunkName: "productadd" */ 'views/products/ProductAdd.vue')
          }
        ]
      },
      {
        path: WBK_PATH,
        name: WBK_PATHNAME,
        component: Wbks,
        meta: {
          requireAuth: true
        },
        redirect: { name: WBK_LIST_PATHNAME },
        children: [
          {
            path: WBK_LIST_PATH,
            name: WBK_LIST_PATHNAME,
            component: () => import(/* webpackChunkName: "wbk" */ 'views/whiteBoxKeys/WhiteBoxKeyList.vue')
          }
        ]
      },
      {
        path: KS_PATH,
        name: KS_PATHNAME,
        component: Ks,
        meta: {
          requireAuth: true
        },
        redirect: { name: KS_LIST_PATHNAME },
        children: [
          {
            path: KS_LIST_PATH,
            name: KS_LIST_PATHNAME,
            component: () => import(/* webpackChunkName: "ks" */ 'views/keySets/KeySetList.vue')
          }
        ]
      },
      {
        path: BW_CRT_PATH,
        name: BW_CRT_PATHNAME,
        component: BWCrts,
        meta: {
          requireAuth: true
        },
        redirect: { name: BW_CRT_LIST_PATH },
        children: [
          {
            path: BW_CRT_LIST_PATH,
            name: BW_CRT_LIST_PATHNAME,
            component: () => import(/* webpackChunkName: "bwcrt" */ 'views/bwCertificates/BWCertificateList.vue')
          }
        ]
      },
      {
        path: TOKEN_PATH,
        name: TOKEN_PATHNAME,
        component: Tokens,
        meta: {
          requireAuth: true,
          restrictAccess: true
        },
        redirect: { name: TOKEN_LIST_PATH },
        children: [
          {
            path: TOKEN_LIST_PATH,
            name: TOKEN_LIST_PATHNAME,
            component: () => import(/* webpackChunkName: "token" */ 'views/tokens/TokenList.vue')
          },
          {
            path: TOKEN_EDIT_PATH,
            name: TOKEN_EDIT_PATHNAME,
            component: () => import(/* webpackChunkName: "tokenedit" */ 'views/tokens/TokenEdit.vue'),
            beforeEnter (to, from, next) {
              if (!to.params.tkToUpdate) {
                next({ name: TOKEN_PATHNAME })
              } else {
                next()
              }
            }
          },
          {
            path: TOKEN_ADD_PATH,
            name: TOKEN_ADD_PATHNAME,
            component: () => import(/* webpackChunkName: "tokenadd" */ 'views/tokens/TokenAdd.vue')
          }
        ]
      },
      {
        path: IDSREPORTPOLICY_PATH,
        name: IDSREPORTPOLICY_PATHNAME,
        component: IdsReportPolicies,
        meta: {
          requireAuth: true
        },
        redirect: { name: IDSREPORTPOLICY_OS_PATHNAME },
        children: [
          {
            path: IDSREPORTPOLICY_OS_PATH,
            name: IDSREPORTPOLICY_OS_PATHNAME,
            component: () => import(/* webpackChunkName: "idsreportpolicies" */ 'views/idsreportpolicies/IdsReportPlcOS.vue')
          },
          {
            path: IDSREPORTPOLICY_CLIENT_PATH,
            name: IDSREPORTPOLICY_CLIENT_PATHNAME,
            component: () => import(/* webpackChunkName: "idsreportpolicies" */ 'views/idsreportpolicies/IdsReportPlcClientList.vue')
          },
          {
            path: IDSREPORTPOLICY_DETAIL_PATH,
            name: IDSREPORTPOLICY_DETAIL_PATHNAME,
            component: () => import(/* webpackChunkName: "idsreportplcdetails" */ 'views/idsreportpolicies/idsReportPlcDetails/IdsReportPlcDetails.vue'),
            beforeEnter (to, from, next) {
              if (!to.params.id) {
                next({ name: IDSREPORTPOLICY_PATHNAME })
              } else {
                next()
              }
            }
          },
          {
            path: ADD_IDSREPORTPOLICY_PATH,
            name: ADD_IDSREPORTPOLICY_PATHNAME,
            component: () => import(/* webpackChunkName: "addidsreportpolicies" */ 'views/idsreportpolicies/idsReportPlcAdd/IdsReportPlcAdd.vue')
          },
          {
            path: EDIT_IDSREPORTPOLICY_PATH,
            name: EDIT_IDSREPORTPOLICY_PATHNAME,
            component: () => import(/* webpackChunkName: "editidsreportpolicies" */ 'views/idsreportpolicies/idsReportPlcEdit/IdsReportPlcEdit.vue'),
            beforeEnter (to, from, next) {
              if (!to.params.id || !to.params.rplcJson || !to.params.title) {
                next({ name: IDSREPORTPOLICY_PATHNAME })
              } else {
                next()
              }
            }
          },
          {
            path: DUPLICATE_IDSREPORTPOLICY_PATH,
            name: DUPLICATE_IDSREPORTPOLICY_PATHNAME,
            component: () => import(/* webpackChunkName: "dupidsreportpolicies" */ 'views/idsreportpolicies/idsReportPlcDup/IdsReportPlcDup.vue'),
            beforeEnter (to, from, next) {
              if (!to.params.id || !to.params.rplcJson || !to.params.title) {
                next({ name: IDSREPORTPOLICY_PATHNAME })
              } else {
                next()
              }
            }
          }
        ]
      },
      {
        path: IDSREPORTPOLICY_TEMP_PATH,
        name: IDSREPORTPOLICY_TEMP_PATHNAME,
        meta: {
          requireAuth: true
        },
        component: IdsReportPolicyTemps,
        redirect: { name: IDSREPORTPOLICY_TEMP_OS_PATHNAME },
        children: [
          {
            path: IDSREPORTPOLICY_TEMP_OS_PATH,
            name: IDSREPORTPOLICY_TEMP_OS_PATHNAME,
            component: () => import(/* webpackChunkName: "idsreportplctemp" */ 'views/idsreportpolicyTemps/IdsReportPlcTempOS.vue')
          },
          {
            path: IDSREPORTPOLICY_TEMP_DETAIL_PATH,
            name: IDSREPORTPOLICY_TEMP_DETAIL_PATHNAME,
            component: () => import(/* webpackChunkName: "idsreportplctempdetail" */ 'views/idsreportpolicyTemps/idsReportPlcTempDetails/IdsReportPlcTempDetails.vue'),
            beforeEnter (to, from, next) {
              if (!to.params.id) {
                next({ name: IDSREPORTPOLICY_TEMP_PATHNAME })
              } else {
                next()
              }
            }
          },
          {
            path: IDSREPORTPOLICY_TEMP_EDIT_PATH,
            name: IDSREPORTPOLICY_TEMP_EDIT_PATHNAME,
            component: () => import(/* webpackChunkName: "idsreportplctempedit" */ 'views/idsreportpolicyTemps/idsReportPlcTempEdit/IdsReportPlcTempEdit.vue'),
            beforeEnter (to, from, next) {
              if (!to.params.id || !to.params.tempJson || !to.params.title) {
                next({ name: IDSREPORTPOLICY_TEMP_PATHNAME })
              } else {
                next()
              }
            }
          },
          {
            path: IDSREPORTPOLICY_TEMP_ADD_PATH,
            name: IDSREPORTPOLICY_TEMP_ADD_PATHNAME,
            component: () => import(/* webpackChunkName: "idsreportplctempadd" */ 'views/idsreportpolicyTemps/idsReportPlcTempAdd/IdsReportPlcTempAdd.vue')
          }
        ]
      }
    ]
  },
  {
    // Neither path nor name found
    path: '*',
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0, behavior: 'smooth' }
  }
})

router.beforeEach((to, from, next) => {
  // Check if authorized
  store.dispatch('checkLoginAction')

  // Check if access is restricted
  if (to.meta.restrictAccess) {
    if (store.state.userName !== 'sds' && store.state.userName !== 'bw') {
      next({
        path: LOGIN_PATH,
        // Back to the location after logged in
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  }

  // Find in array if contains requireAuth
  if (to.matched.some(record => record.meta.requireAuth)) {
    if (!store.state.isLoggedIn) {
      next({
        path: LOGIN_PATH,
        // Back to the location after logged in
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
